import { numberFormatter } from '@fortem-monorepo/js-utilities'
import { createColDefs } from '@fortem-monorepo/react-ag'
import { CustomAgGrid } from '@fortem-monorepo/react-ag'
import { Widget, WidgetContent, WidgetHeaderWithQuery } from '@fortem-monorepo/react-spa'
import { ManagementReport } from '@fortem-monorepo/web-sdk'

import { useManagementReportQuery } from '@/pages/funds/management-report/query'
import { ManagementReportWidget } from '@/pages/funds/management-report/types'

export interface TrackingDifferencesGridProps extends ManagementReportWidget {}

export const TrackingDifferencesGrid: React.FC<TrackingDifferencesGridProps> = ({ params }) => {
  const query = useManagementReportQuery(params)

  return (
    <Widget>
      <WidgetHeaderWithQuery query={query} title="Tracking Differences" />
      <WidgetContent loading={query.isLoading}>
        <CustomAgGrid
          query={query}
          rowData={query.data?.tracking_differences}
          columnDefs={makeColDefs()}
          statusBar={{ statusPanels: [] }}
        />
      </WidgetContent>
    </Widget>
  )
}

const formatter = numberFormatter({
  suffix: '%',
  transformer(val) {
    return val * 100
  },
})

const makeColDefs = () => {
  return createColDefs<
    Required<ManagementReport.GetManagementReportData>['tracking_differences'][number]
  >([
    {
      field: 'index',
      headerName: '',
    },
    {
      field: '1_month',
      headerName: '1m',
      cellClass: 'text-center',
      valueFormatter: formatter,
    },
    {
      field: 'calendar_ytd',
      headerName: 'YTD',
      cellClass: 'text-center',
      valueFormatter: formatter,
    },
    {
      field: '1_year',
      headerName: '1Y',
      cellClass: 'text-center',
      valueFormatter: formatter,
    },
    {
      field: 'since_inception',
      headerName: 'Since Inception',
      cellClass: 'text-center',
      valueFormatter: formatter,
    },
  ])
}
